import axios from "axios";

export async function getMemeCount() {
  const memeCount = await axios.get("https://solanapulseserver-production-9af7.up.railway.app/totalai").then((res) => res.data);
  return memeCount;
}
